/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Label_RegistrantInputs */

const en_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrant name`)
};

const es_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del participante`)
};

const de_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Teilnehmers`)
};

const zh_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报名人姓名`)
};

const ar_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم المسجّل`)
};

const fr_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du participant`)
};

const vi_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên người đăng ký`)
};

const sw_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina la mshiriki`)
};

const th_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อผู้ลงทะเบียน`)
};

const bs_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ime učesnika`)
};

const ja_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加登録者名`)
};

const ko_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록자 이름`)
};

const pt_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do inscrito`)
};

const it_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del partecipante`)
};

const sv_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deltagarens namn`)
};

const nl_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam deelnemer`)
};

const da_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deltagerens navn`)
};

const nb_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deltakerens navn`)
};

const fi_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osallistujan nimi`)
};

const pl_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko uczestnika`)
};

const ru_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя участника`)
};

const tr_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katılımcı adı`)
};

const hi_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिभागी का नाम`)
};

const id_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama peserta`)
};

const ms_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama pendaftar`)
};

const cs_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno účastníka`)
};

const el_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Όνομα συμμετέχοντα`)
};

const he_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שם הנרשם`)
};

const af_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van deelnemer`)
};

const hu_events_label_registrant = /** @type {(inputs: Events_Label_RegistrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résztvevő neve`)
};

/**
* | output |
* | --- |
* | "Registrant name" |
*
* @param {Events_Label_RegistrantInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_label_registrant = /** @type {((inputs?: Events_Label_RegistrantInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Label_RegistrantInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_label_registrant(inputs)
	if (locale === "de") return de_events_label_registrant(inputs)
	if (locale === "zh") return zh_events_label_registrant(inputs)
	if (locale === "ar") return ar_events_label_registrant(inputs)
	if (locale === "fr") return fr_events_label_registrant(inputs)
	if (locale === "vi") return vi_events_label_registrant(inputs)
	if (locale === "sw") return sw_events_label_registrant(inputs)
	if (locale === "th") return th_events_label_registrant(inputs)
	if (locale === "bs") return bs_events_label_registrant(inputs)
	if (locale === "ja") return ja_events_label_registrant(inputs)
	if (locale === "ko") return ko_events_label_registrant(inputs)
	if (locale === "pt") return pt_events_label_registrant(inputs)
	if (locale === "it") return it_events_label_registrant(inputs)
	if (locale === "sv") return sv_events_label_registrant(inputs)
	if (locale === "nl") return nl_events_label_registrant(inputs)
	if (locale === "da") return da_events_label_registrant(inputs)
	if (locale === "nb") return nb_events_label_registrant(inputs)
	if (locale === "fi") return fi_events_label_registrant(inputs)
	if (locale === "pl") return pl_events_label_registrant(inputs)
	if (locale === "ru") return ru_events_label_registrant(inputs)
	if (locale === "tr") return tr_events_label_registrant(inputs)
	if (locale === "hi") return hi_events_label_registrant(inputs)
	if (locale === "id") return id_events_label_registrant(inputs)
	if (locale === "ms") return ms_events_label_registrant(inputs)
	if (locale === "cs") return cs_events_label_registrant(inputs)
	if (locale === "el") return el_events_label_registrant(inputs)
	if (locale === "he") return he_events_label_registrant(inputs)
	if (locale === "af") return af_events_label_registrant(inputs)
	if (locale === "hu") return hu_events_label_registrant(inputs)
	return en_events_label_registrant(inputs)
});